<div attr.data-col="{{this.col}}" [ngClass]="{'hidden': hide == true, 'form-group': this.noDiv == true}">
  <label *ngIf="!this.noDiv">{{this.label}}</label>
  <ng-container *ngIf="this.type === 'currency'; then valuta; else noValuta">
  </ng-container>
  <ng-template #valuta>
    <input #currencyField currencyMask [(ngModel)]="inputModel" (ngModelChange)="inputModelChange.emit(inputModel)" class="form-control {{this.class}}" type="{{this.internalType}}" placeholder="{{this.placeholder}}" name="{{this.name}}" disabled="{{this.disabled}}">
    <span>{{errore}}</span>
  </ng-template>
  <ng-template #noValuta>
    <input #inputField [ngClass]="toUpper ? 'uppercase' : ''" [(ngModel)]="inputModel" (ngModelChange)="inputModelChange.emit(inputModel)" attr.maxlength="{{this.maxlength}}" class="form-control {{this.class}}" type="{{this.internalType}}" placeholder="{{this.placeholder}}"
      name="{{this.name}}" disabled="{{this.disabled}}">
    <span>{{errore}}</span>
    <em #deleteAllIcon class="fa fa-times deleteAll" (click)="deleteText()"></em>
  </ng-template>
</div>